/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicDailyCostReport extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicDailyCostReport");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicDailyCostReport.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicDailyCostReport>): BackgroundJobPayloadForPeriodicDailyCostReport {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicDailyCostReport(), model);
        BackgroundJobPayloadForPeriodicDailyCostReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicDailyCostReport>): BackgroundJobPayloadForPeriodicDailyCostReport {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicDailyCostReport.newInstance(<BackgroundJobPayloadForPeriodicDailyCostReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicDailyCostReport) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicDailyCostReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicDailyCostReport): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicDailyCostReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
